import { render, staticRenderFns } from "./DiagnosticTab.vue?vue&type=template&id=0b937c28&scoped=true"
import script from "./DiagnosticTab.vue?vue&type=script&lang=js"
export * from "./DiagnosticTab.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticTab.vue?vue&type=style&index=0&id=0b937c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b937c28",
  null
  
)

export default component.exports